export function formatMoney(value: number, locale: string, currency: string): string {
  const amount = Number.isFinite(value) ? value : 0;
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
}

export function formatPercent(value: number): string {
  const amount = Number.isFinite(value) ? value : 0;
  return `${amount.toFixed(2)}%`;
}
